import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Box, Flex, mode, Text, useColorMode } from '@abb/uikit';
import { ChevronRight } from '@abb/uikit/icons/outline/arrow';
import { Check } from '@abb/uikit/icons/outline/general';
import { Moon01, Sun } from '@abb/uikit/icons/solid/weather';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Contrast02 from 'shared-components/icons/Contrast-icon';
import { setColorMode } from 'utils/setColorMode';
import { HeaderResponsive } from './HeaderResponsive';
export const ColorModeResponsive = (param)=>{
    let { onSidebarOpen } = param;
    const { t } = useTranslation('common');
    const { colorMode, toggleColorMode } = useColorMode();
    const [open, setOpen] = useState(false);
    const onCloseDrower = ()=>{
        setOpen(false);
        onSidebarOpen();
    };
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsxs(Flex, {
                p: "12px 24px",
                onClick: ()=>setOpen(!open),
                w: "100%",
                alignItems: "center",
                justifyContent: "space-between",
                children: [
                    /*#__PURE__*/ _jsxs(Flex, {
                        alignItems: "center",
                        gap: 3,
                        children: [
                            /*#__PURE__*/ _jsx(Contrast02, {}),
                            /*#__PURE__*/ _jsxs(Box, {
                                textAlign: "start",
                                children: [
                                    /*#__PURE__*/ _jsx(Text, {
                                        children: t('user_settings.color_mode')
                                    }),
                                    /*#__PURE__*/ _jsx(Text, {
                                        fontSize: "14px",
                                        color: "#7A7D82",
                                        children: t(`user_settings.${colorMode}`)
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx(ChevronRight, {})
                ]
            }),
            open && /*#__PURE__*/ _jsxs(Box, {
                borderRadius: "24px",
                p: 3,
                bg: mode('#F0F0F0', '#0A0B0D')({
                    colorMode
                }),
                position: "fixed",
                zIndex: 2,
                top: "0",
                left: 0,
                h: "calc(100dvh - 16px)",
                w: "100%",
                children: [
                    /*#__PURE__*/ _jsx(HeaderResponsive, {
                        onCloseSidebar: onCloseDrower,
                        responsiveSetOpenModal: setOpen,
                        responsiveOpenModal: open
                    }),
                    /*#__PURE__*/ _jsxs(Flex, {
                        borderRadius: "12px",
                        bg: colorMode === 'light' ? mode('#F5F5F5', '#484A4F')({
                            colorMode
                        }) : 'transparent',
                        onClick: ()=>colorMode === 'dark' && setColorMode('light', toggleColorMode),
                        p: 3,
                        w: "100%",
                        gap: 3,
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ _jsx(Sun, {
                                fill: "#F0F0F0",
                                stroke: mode('black', '#F0F0F0')({
                                    colorMode
                                })
                            }),
                            /*#__PURE__*/ _jsxs(Flex, {
                                w: "100%",
                                justifyContent: "space-between",
                                alignItems: "center",
                                children: [
                                    /*#__PURE__*/ _jsx(Text, {
                                        children: t('user_settings.light')
                                    }),
                                    colorMode === 'light' && /*#__PURE__*/ _jsx(Check, {})
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs(Flex, {
                        borderRadius: "12px",
                        bg: colorMode === 'dark' ? mode('#F5F5F5', '#484A4F')({
                            colorMode
                        }) : 'transparent',
                        onClick: ()=>colorMode === 'light' && setColorMode('dark', toggleColorMode),
                        p: 3,
                        w: "100%",
                        gap: 3,
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ _jsx(Moon01, {
                                fill: "#F0F0F0",
                                stroke: mode('black', '#F0F0F0')({
                                    colorMode
                                })
                            }),
                            /*#__PURE__*/ _jsxs(Flex, {
                                justifyContent: "space-between",
                                alignItems: "center",
                                children: [
                                    /*#__PURE__*/ _jsx(Text, {
                                        children: t('user_settings.dark')
                                    }),
                                    colorMode === 'dark' && /*#__PURE__*/ _jsx(Check, {})
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
